const authInitialState = {
  auth: {
    loading: false,
    error: null,
    data: null,
  },
  authTraza: {
    loading: false,
    error: null,
    data: null,
  },
  biometric: {
    isAvailable: false,
    biometryType: 0,
    isEnabled: false,
    lastUser: null,
    error: null,
  },
};

export default authInitialState;
